/* eslint-disable @nx/enforce-module-boundaries */
import { MFieldChatProps } from './MFieldChat.types';
import * as Styled from './MFieldChat.styles';
import { AIcon } from '@marriott/mi-web-ui-kit';
import { ATextArea } from '../../atoms/ATextArea';
import clsx from 'clsx';

const COMPONENT_NAME = 'm-mi-chat-components-MFieldChat';
const TEST_ID = 'mi-chat-components-MFieldChat';

export function MFieldChat({
  aIcon,
  aInputText,
  className,
  inputRef,
  iconRef,
  onIconClick,
  clickTrackClass,
  clickTrackValue,
  isDisabled,
  trackLabel,
  iconButtonAriaLabel,
}: MFieldChatProps) {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      isDisabled={isDisabled}
    >
      <Styled.InputWrapper>
        <ATextArea ref={inputRef} {...aInputText} />
      </Styled.InputWrapper>
      {aIcon && (
        <Styled.IconWrapper
          ref={iconRef}
          type="button"
          aria-label={iconButtonAriaLabel}
          disabled={isDisabled}
          onClick={onIconClick}
          className={clsx(clickTrackClass)}
          {...(clickTrackValue && { 'data-custom_click_track_value': clickTrackValue })}
          {...(trackLabel && { 'data-track-label': trackLabel })}
          isDisabled={isDisabled}
        >
          <AIcon {...aIcon} aria-hidden="true" />
        </Styled.IconWrapper>
      )}
    </Styled.Wrapper>
  );
}

export { TEST_ID as M_FIELD_CHAT_TEST_ID };
